__webpack_require__.p = "https://friendly-ardinghelli-f9e382.netlify.app/";